import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { switchMap } from 'rxjs';
/**
 * The Servie for the PushMessages
 */
@Injectable({
  providedIn: 'root'
})
export class PushService {
  /**
   * constructor
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) { }

  /**
   * Get the PushMessages via the Filter
   * @param page 
   * @param size 
   * @param type 
   * @param sort 
   * @param searchTerm 
   * @returns 
   */
  filterPushMessages(page: number, size: number, type, sort: string, searchTerm: string) {
    const body = {
      "searchTerm": searchTerm,
      "isSend": false,
      "isNotSend": true,
      "filterByTypes": type
    }
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/pushmessage/search?page=${page}&size=${size}&sort=${sort}`, body)
      )
    )
  }
  /**
   * Create a new PushMessages
   * @param push 
   * @returns 
   */
  createPushMessage(push) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/pushmessage`, push)
      )
    )
  }
  /**
   * Get a PushMessages via the ID
   * @param pushID 
   * @returns 
   */
  getPushMessage(pushID) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/pushmessage/${pushID}`, {})
      )
    )
  }
  /**
   * Edit a PushMessage
   * @param push 
   * @returns 
   */
  editPushMessage(push) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/pushmessage/`, push)
      )
    )
  }
  /**
   * Duplicate the PushMessage
   * @param push 
   * @returns 
   */
  duplicatePushMessage(push) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/pushmessage/duplicate`, push)
      )
    )
  }
  /**
   * Delete the PushMessage
   * @param pushID 
   * @returns 
   */
  deletePushMessage(pushID) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.delete(`${url}/pushmessage/${pushID}`, {})
      )
    )
  }
  /**
   * Send the PushMessage now
   * @param push 
   * @returns 
   */
  sendInstantPushMessage(push) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/pushmessage/send`, push)
      )
    )
  }
  /**
   * Get the PushMessages via the Filter (only for EVENTS)
   * @param size 
   * @param page 
   * @param searchTerm 
   * @returns 
   */
  searchForPushMessage(size: number, page: number, searchTerm: string) {
    const body = {
      "searchTerm": searchTerm,
      "isSend": false,
      "isNotSend": true,
      "filterByTypes": ["EVENTS"]
    }
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/pushmessage/search?page=${page}&size=${size}`, { body })
      )
    )
  }
}
